import type { JSX } from "react";
import { heatIntensity } from "./geometry";

const DOW = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export function Heatmap({ cells }: { cells: { dow: number; hour: number; count: number }[] }): JSX.Element {
  const max = Math.max(0, ...cells.map((c) => c.count));
  const lookup = new Map(cells.map((c) => [`${c.dow}-${c.hour}`, c.count]));
  return (
    <div className="cc-heatmap">
      {DOW.map((day, d) => (
        <div key={day} className="cc-heatmap-row">
          <span className="cc-heatmap-day">{day}</span>
          {Array.from({ length: 24 }, (_, h) => {
            const count = lookup.get(`${d}-${h}`) ?? 0;
            const intensity = heatIntensity(count, max);
            return (
              <span key={h} className="cc-heatmap-cell" title={`${day} ${h}:00 — ${count}`}
                style={{ background: count === 0 ? "var(--bg-raised)" : `color-mix(in srgb, var(--color-success) ${Math.round(14 + intensity * 66)}%, var(--bg-raised))` }} />
            );
          })}
        </div>
      ))}
    </div>
  );
}
